import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useOrganization } from "../../App";
import OrganizationSettings from "../organization/OrganizationSettings";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import { LoadingScreen } from "../ui/loading-spinner";

export default function OrganizationSettingsPage() {
  const { currentOrganization, isLoading } = useOrganization();
  const navigate = useNavigate();
  const { organizationId } = useParams();

  useEffect(() => {
    // If we have a current organization and we're on the base path,
    // redirect to the specific organization settings page
    if (currentOrganization && !organizationId) {
      navigate(`/organization-settings/${currentOrganization.id}`);
    }
  }, [currentOrganization, navigate, organizationId]);

  if (isLoading) {
    return <LoadingScreen text="Loading organization..." />;
  }

  if (!currentOrganization) {
    return (
      <DashboardLayout activeItem="Settings">
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <h2 className="text-2xl font-bold">No Organization Found</h2>
            <p className="mt-2">
              You need to be part of an organization to access settings.
            </p>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout activeItem="Settings">
      <OrganizationSettings />
    </DashboardLayout>
  );
}
